import { AnyAction } from "redux";
import {
  clearCustomerAccountCache,
  clearDiscount,
  clearNewCustomer,
  setCartItems,
  setCartKitchenId,
  setCustomerAccountCache,
  setCustomerDetails,
  setDeliveryAddress,
  setDiscount,
  setNewCustomer,
  setOrderNote,
  setPaymentProcessing,
  setScheduledTime,
} from "./cart.action";
import {
  CartItem,
  CustomerAccountCache,
  CustomerDetails,
  DeliveryAddress,
} from "./cart.types";
import { DiscountCode } from "../../utils/firestore/getDiscounts";
import { Customer } from "../../utils/types";

export type CartState = {
  cartItems: CartItem[];
  kitchenId: string;
  orderNote: string;
  scheduledTime: Date | string | null;
  deliveryAddress: DeliveryAddress | null;
  customerDetails: CustomerDetails;
  discount: DiscountCode;
  customer?: Customer;
  customerAccountCache?: CustomerAccountCache;
  isPaymentProcessing: boolean;
};

export const CART_INITIAL_STATE: CartState = {
  cartItems: [],
  kitchenId: "",
  orderNote: null,
  scheduledTime: null,
  deliveryAddress: null,
  customerDetails: {
    customerEmail: null,
    customerName: null,
    customerMobile: null
  },
  discount: null,
  isPaymentProcessing: false,
};

export const cartReducer = (
  state = CART_INITIAL_STATE,
  action: AnyAction
): CartState => {
  if (setCartItems.match(action)) {
    return {
      ...state,
      cartItems: action.payload,
      ...(action.payload.length === 0 ? { deliveryAddress: null } : {}),
    };
  }

  if (setCartKitchenId.match(action)){
    return {
      ...state,
      kitchenId: action.payload
    }
  }
  if (setScheduledTime.match(action)){
    return {
      ...state,
      scheduledTime: action.payload
    }
  }
  if(setOrderNote.match(action)){
    return{
      ...state,
      orderNote: action.payload
    }
  }
  if(setCustomerDetails.match(action)){
    return{
      ...state,
      customerDetails: action.payload
    }
  }

  if(setDiscount.match(action)){
    return{
      ...state,
      discount: action.payload
    }
  }

  if (clearDiscount.match(action)) {
    return {
      ...state,
      discount: action.payload
    }
  }

  if (setNewCustomer.match(action)) {
    return {
      ...state,
      customer: action.payload,
    };
  }

  if (setCustomerAccountCache.match(action)) {
    return {
      ...state,
      customerAccountCache: action.payload,
    };
  }

  if (clearNewCustomer.match(action)) {
    const { customer, ...rest } = state;
    return rest;
  }

  if (clearCustomerAccountCache.match(action)) {
    const { customerAccountCache, ...rest } = state;
    return rest;
  }

  if (setPaymentProcessing.match(action)) {
    return {
      ...state,
      isPaymentProcessing: action.payload,
    };
  }

  if (setDeliveryAddress.match(action)) {
    return {
      ...state,
      deliveryAddress: action.payload,
    };
  }

  return state;
};
